
import { IconButton, LinearProgress, Link } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";
import { TransactionFeeModel } from "../../models/TransactionModel";
import { EmailReportModuleModel } from '../../models/EmailReportModuleModel';
import { PolicyCheckResult } from "../../Pages/PolicyChecksResult";
import { apiClient } from "../../helper/api";


const initValue: EmailReportModuleModel = {
    emailReportId: 0,
    customerName: "",
    templateName: "",
    emailSent: false,
    stateName: "",
    emailSendDate: "",
    blob_Address: "",
    content: ""
}
const emailReports: EmailReportModuleModel[] = [
    { ...initValue },
];

// Helper function to strip HTML tags and decode HTML entities
const decodeHtmlContent = (html: string): string => {
    if (!html) return '';
    let text = html;
    // Remove style tags and their content
    text = text.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
    // Remove script tags and their content
    text = text.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
    // Remove head tags and their content
    text = text.replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '');
    // Remove comments (including CSS comments that might be outside style tags)
    text = text.replace(/<!--[\s\S]*?-->/g, '');
    text = text.replace(/\/\*[\s\S]*?\*\//g, '');
    // Strip remaining HTML tags
    text = text.replace(/<[^>]+>/g, '');
    // Decode HTML entities using a temporary element
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    // Clean up extra whitespace
    return textarea.value.replace(/\s+/g, ' ').trim();
};

export const EmailReportsDetails = () => {
    const [EmailReportModuleDetails, setEmailReportModule] = useState(emailReports);

    // const [feeComparison, setFeecomparison] = useState(initialFeecomaprison);
    const { user } = useAuth();
    const token = user?.token;




    useEffect(() => {
        setloading(true);

        fetchData();

    }, [])

    const fetchData = () => {
        setloading(true);
        apiClient(`/EmailReports/GetEmailReportsDetails?EmailReportId=${params.emailReportId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                // Do something with the response
                
                setEmailReportModule(responseJson.data)
                console.log("butlerdata", responseJson.data)
            }).finally(() => {
                setloading(false);
            });


    }



    const initialTransactionFee: TransactionFeeModel = {
        taxName: "", rate: 0, rateType: "", calculatedFee: 0, premium: 0, policyFee: 0, stampingFee: 0,
        techInterfacefee: 0,
        brokerFee: 0,
        transactionType: 0,
        inspectionFee: '',
        stateTax: ''
    }
    const [loading, setloading] = useState(false);

    // const [Transaction, settransactions] = React.useState(initialTransaction);
    const [TransactionFees, setTransactionFees] = React.useState([initialTransactionFee]);

    const params = useParams();

    return (
        <React.Fragment>

            <div style={{ marginTop: "4px" }}>
                {/* <span className="text-center"><h3>Email Report Details</h3></span> */}
                {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}
            </div>



            <div className="row row-cols-1 row-cols-md-3 g-4 m-0 ">

                <div className="col-lg-6 col-sm-12">


                    <div className="card dashboard-table" style={{ height: "460px" }}>

                        <span className="card-title">Email Details</span>
                        <div className="table-responsive">
                            {
                                <table className="table">
                                    <tbody>

                                        <tr className="align-middle " >
                                            <td>Template Name</td>
                                            <td>{EmailReportModuleDetails[0]?.templateName}</td>
                                        </tr>
                                        <tr className="align-middle">
                                            <td>Email Subject</td>
                                            <td>{EmailReportModuleDetails[0]?.subject?.toString()}</td>
                                        </tr>
                                        <tr className="align-middle">
                                            <td>CC</td>
                                            <td>{EmailReportModuleDetails[0]?.cc?.toString()}</td>
                                        </tr>
                                        <tr className="align-middle">
                                            <td>BCC</td>
                                            <td>{EmailReportModuleDetails[0]?.bcc?.toString()}</td>
                                        </tr>
                                        <tr className="align-middle">
                                            <td>TO</td>
                                            <td>{EmailReportModuleDetails[0]?.mailSentTo?.toString()}</td>
                                        </tr>
                                        <tr className="align-middle">
                                            <td>Customer</td>
                                            <td>{EmailReportModuleDetails[0]?.customerName?.toString()}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="card dashboard-table" style={{ height: "460px" }}>
                        <span className="card-title">Attachments</span>
                        <div className="table-responsive">
                            <table className="table">
                                <tbody>
                                    {EmailReportModuleDetails.map((email, key) =>
                                        <tr key={key}>
                                            <td>
                                                <div style={{ maxWidth: '920px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <Link href={email.blob_Address} sx={{ textDecoration: "none " }} target="_blank" rel="noopener noreferrer">
                                                        {email.documentName}
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>


                        </div>
                    </div>
                </div>
            </div>
            <div className="row row-cols-1 row-cols-md-3 g-4 m-0 ">
                <div className="col-lg-12 col-sm-12">

                    <div className="card dashboard-table" style={{ height: "300px" }}>

                        <div className="table-responsive">
                            {
                                <table className="table">
                                    <tbody>
                                        <tr className="align-middle">
                                            <td className="col-lg-2">Content</td>
                                            <td className="col-12">
                                                {typeof EmailReportModuleDetails[0]?.content === 'string' ? decodeHtmlContent(EmailReportModuleDetails[0]?.content) : ''}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment >
    )
}
